module.exports = __webpack_public_path__ + "img/picture_notmember_screenshot_MAGAZINE.997876d3.png";